






import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component<ExpireTime>({
  mounted() {
    this.interval = setInterval(() => {
      this.currentDate = new Date();
    }, 1000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
})
export default class ExpireTime extends Vue {
  @Prop() expiredTime: string;

  interval: number;

  currentDate = new Date();

  get timerData(): number[] {
    const secs = moment
      .duration(moment(this.expiredTime).diff(moment(this.currentDate)))
      .asSeconds();
    const hours = Math.floor(secs / 3600);
    const minutes = Math.floor((secs - hours * 3600) / 60);
    const seconds = Math.floor(secs - (hours * 3600 + minutes * 60));
    return [hours, minutes, seconds];
  }

  get timer(): string {
    return this.timerData
      .map((num) => String(num))
      .map((num) => num.padStart(2, '0'))
      .join(':');
  }

  get show(): boolean {
    return this.timerData[0] < 24 && this.timerData.every((i) => i >= 0);
  }
}
